import React, { FC, useState, useEffect } from 'react'
import get from 'lodash/get'
import { useGetProductRecommendById } from '../../hooks/useGetProducts'
import { CollectionSkeleton } from '../skeleton'
import Product from '../Product'

interface Props {
  title?: any
  proudctId?: string
}
const ProductsRecommend: FC<Props> = ({ title, proudctId }) => {
  const [list, setList] = useState([])
  const { query } = useGetProductRecommendById(proudctId as string)
  const info = get(query, 'data.productRecommendations')
  useEffect(() => {
    if (info) {
      setList(info)
    }
  }, [info])

  return (
    <div className="productlist-wrapper pt-4 px-3 pb-3">
      {list.length > 0 ? (
        <>
          {title && (
            <div className="text-black text-sm font-semibold pb-3 md:text-center md:text-lg md:mt-14 md:pb-8">
              {title}
            </div>
          )}
          <div className="product-list grid grid-cols-2 gap-x-3 md:gap-x-5 md:grid-cols-4 pb-6">
            {list.map((i: any, index) => (
              <Product
                className="mb-6"
                data={i}
                key={i.id}
                productIndex={index + 1}
                collectionTitle="You May Also Like"
                moduleName="You May Also Like"
              />
            ))}
          </div>
        </>
      ) : (
        <CollectionSkeleton count={10} />
      )}
    </div>
  )
}

export default ProductsRecommend
